import { successAction, GET_PERMISSION, GET_COLUMNS } from '../types';

const initialState = {
  userName: '',
  permissions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(GET_PERMISSION): {
      return {
        ...state,
        userName: action.payload.username,
        permissions: action.payload.permissions,
      };
    }
    case successAction(GET_COLUMNS): {
      const [list, selected] = action.payload;
      return {
        ...state,
        columns: {
          list,
          selected: selected.fields,
        },
      };
    }
    default:
      return state;
  }
};
